import styled from 'styled-components/macro';

export const StyledLoaderContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: rgba(250, 250, 250, 0.5);
`;
